// Extraction mécanique de client.ts (WO-V3-02 / US-019) — méthodes API du domaine.
import { request } from './http'
import type { ComparisonDetail, ComparisonSummary, Pipeline, PipelineRun, PipelineStage, WorkspaceGovernance } from './types/collaboration'

export const comparisonsAndPipelinesApi = {
  // --- Comparaison multi-modèles (Écran 4) ---

  /** Lance une comparaison : le même prompt sera rejoué sur chaque modèle par le worker.
   *  `source` est un lien STRUCTUREL (référence vérifiée côté serveur) vers le document
   *  d'où vient `prompt` — jamais une preuve suffisante en elle-même : c'est le champ
   *  `source_id` renvoyé ensuite qui atteste le lien, pas ce texte. */
  createComparison: (workspaceId: string, prompt: string, modelIds: string[], source?: {
    sourceKind: 'approval' | 'document'
    sourceId: string
    sourceSectionLabel?: string
  }) =>
    request<{ id: number; job_id: string; trace_id: string; status: string }>('/comparisons', {
      method: 'POST',
      body: JSON.stringify({
        workspace_id: workspaceId, prompt, model_ids: modelIds,
        source_kind: source?.sourceKind, source_id: source?.sourceId,
        source_section_label: source?.sourceSectionLabel,
      }),
    }),

  listComparisons: (workspaceId: string) =>
    request<ComparisonSummary[]>(
      `/comparisons?workspace_id=${encodeURIComponent(workspaceId)}`),

  getComparison: (id: number) => request<ComparisonDetail>(`/comparisons/${id}`),
  retryComparison: (id: number) => request<{ id: number; job_id: string; trace_id: string; status: 'pending' }>(
    `/comparisons/${id}/retry`, { method: 'POST' }),
  reviewComparison: (id: number, decision: 'approved' | 'rejected', comment?: string) =>
    request<{ id: number; status: 'approved' | 'rejected'; reviewed_by: string }>(
      `/comparisons/${id}/review`, {
        method: 'POST',
        body: JSON.stringify({ decision, comment: comment?.trim() || undefined }),
      }),

  // --- Pipelines & déploiement (Écran 8) ---

  createPipeline: (workspaceId: string, name: string, stages: PipelineStage[]) =>
    request<{ id: number; name: string }>('/pipelines', {
      method: 'POST',
      body: JSON.stringify({ workspace_id: workspaceId, name, stages }),
    }),

  listPipelines: (workspaceId: string) =>
    request<Pipeline[]>(`/pipelines?workspace_id=${encodeURIComponent(workspaceId)}`),

  /** Lance un run : le worker exécutera les étapes (derrière le drapeau serveur). */
  runPipeline: (id: number) =>
    request<{ run_id: number; job_id: string; status: string }>(
      `/pipelines/${id}/run`, { method: 'POST' }),

  listPipelineRuns: (id: number) => request<PipelineRun[]>(`/pipelines/${id}/runs`),

  /** Gouvernance de l'espace : quotas, modèles autorisés, membres (Admin, Écran 11). */
  governance: (workspaceId: string) =>
    request<WorkspaceGovernance>(
      `/admin/workspace?workspace_id=${encodeURIComponent(workspaceId)}`),

}
